// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const dratini: PokeData = {
  "id": 147,
  "name": "dratini",
  "height": 18,
  "weight": 33,
  "base_experience": 60,
  "types": [
    PokeType.DRAGON
  ],
  "api_moves": [
    "slam",
    "wrap",
    "leer",
    "hyper-beam",
    "dragon-rage",
    "thunder-wave",
    "agility",
    "outrage",
    "safeguard",
    "twister",
    "rain-dance",
    "dragon-dance",
    "aqua-tail",
    "dragon-rush",
    "dragon-tail"
  ],
  "moves": [
    "leer",
    "outrage",
    "rain-dance",
    "dragon-dance",
    "aqua-tail",
    "dragon-rush",
    "dragon-claw",
    "great-roar",
    "dragon-pulse",
    "scale-shot",
    "draco-meteor",
    "dragon-vortex",
    "dragon-breath"
  ],
  "evolution_chain": {
    "id": 76,
    "item": null,
    "species": [
      {
        "name": "dratini",
        "order": 179,
        "types": [
          PokeType.DRAGON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "dragonair",
        "order": 180,
        "types": [
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 147,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "dragonite",
        "order": 181,
        "types": [
          PokeType.DRAGON,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 148,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 55,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 44.25,
    "speed": 50,
    "ability_power": 64
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
